export default "__VITE_ASSET__51044afe__"